import { TrendingUp, Eye, MessageSquare, Zap, Recycle } from 'lucide-react';
import ScrollReveal from './ScrollReveal';

const benefits = [
  {
    icon: TrendingUp,
    title: 'Higher Indexing Rate',
    description: 'Fix rendering and crawl issues so search engines discover more of your pages.',
    stat: 'Up to 3x',
    statLabel: 'more pages indexed',
  },
  {
    icon: Eye,
    title: 'Better Search Visibility',
    description: 'Improve technical SEO foundations that directly impact ranking signals.',
    stat: '40%+',
    statLabel: 'visibility improvement',
  },
  {
    icon: MessageSquare,
    title: 'Improved AI Citations',
    description: 'Get your brand mentioned by ChatGPT, Gemini, Perplexity, and other AI assistants.',
    stat: '4 LLMs',
    statLabel: 'checked for visibility',
  },
  {
    icon: Zap,
    title: 'Faster Discovery',
    description: 'Optimize crawl paths and site structure so bots find content faster.',
    stat: '< 2 min',
    statLabel: 'full analysis time',
  },
  {
    icon: Recycle,
    title: 'Reduced Crawl Waste',
    description: 'Stop wasting crawl budget on duplicate, broken, or low-value pages.',
    stat: '50%+',
    statLabel: 'crawl efficiency gain',
  },
];

const ResultsSection = () => (
  <section className="py-20 md:py-24 bg-white">
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <ScrollReveal>
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-cv-teal/10 text-cv-navy text-xs font-bold uppercase tracking-wider rounded-full border border-cv-teal/40 mb-4">
            Results
          </span>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-cv-navy mb-4">
            Real Impact on Your <span className="text-cv-navy">Visibility</span>
          </h2>
          <p className="text-cv-navy/70 max-w-2xl mx-auto text-lg">
            Teams using Crawler Vision see measurable improvements across search and AI discoverability.
          </p>
        </div>
      </ScrollReveal>

      <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-6">
        {benefits.map((b, i) => (
          <ScrollReveal key={b.title} delay={i * 0.08}>
            <div className="bg-white rounded-2xl border border-cv-teal/40 p-5 text-center h-full hover:shadow-lg hover:border-cv-teal/40 transition-all group">
              <div className="w-11 h-11 rounded-xl bg-cv-teal/10 border border-cv-teal/40 flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <b.icon className="w-5 h-5 text-cv-navy" />
              </div>
              <div className="text-2xl font-extrabold text-cv-navy mb-1">
                {b.stat}
              </div>
              <p className="text-xs text-cv-navy/60 mb-3">{b.statLabel}</p>
              <h3 className="text-sm font-bold text-cv-navy mb-1">{b.title}</h3>
              <p className="text-xs text-cv-navy/60 leading-relaxed">{b.description}</p>
            </div>
          </ScrollReveal>
        ))}
      </div>
    </div>
  </section>
);

export default ResultsSection;
